import type { FC } from "react"
import { HStack, Stack, Text } from "@chakra-ui/react"
import { isAddress } from "@ethersproject/address"

import UserAvatar from "common/components/UserAvatar"
import type { Account } from "query/graphql"
import { isSolanaAddress, shortenIfAddress } from "web3/helpers/address"
import { getDisplayName } from "user/helpers/user"

type VotingModalVoterDataProps = {
  account: Pick<Account, "address" | "name" | "picture" | "twitter">
}

const VotingModalVoterData: FC<VotingModalVoterDataProps> = ({ account }) => {
  const { address, twitter, picture } = account

  const displayName = getDisplayName(account)

  const truncatedAddressOrName =
    isAddress(displayName) || isSolanaAddress(displayName)
      ? shortenIfAddress(displayName)
      : displayName

  return (
    <HStack
      align="flex-start"
      bg="gray.50"
      justify="space-between"
      px={6}
      py={4}
    >
      <Stack isInline align="center" justify="flex-start">
        <UserAvatar
          address={address}
          isVerifiedByTwitter={Boolean(twitter)}
          size="md"
          src={picture}
        />
        <Stack justify="space-between" spacing={1}>
          <Text color="purple.900" textStyle="body.bold.lg">
            {truncatedAddressOrName}
          </Text>
        </Stack>
      </Stack>
    </HStack>
  )
}

export default VotingModalVoterData
